export default __webpack_public_path__ + "static/media/kolkata2.8f447a18.jpg";